// Central registry of data-testid values for the AXIOM UI.

export const NAV = {
  root: "ax-navbar",
  brand: "ax-navbar-brand",
  account: "ax-navbar-account-link",
  admin: "ax-navbar-admin-link",
  codename: "ax-navbar-codename",
  freeBanner: "ax-navbar-free-banner",
  freeBannerCta: "ax-navbar-free-banner-cta",
};

export const AX_HOME = {
  root: "ax-home-root",
  theoryList: "ax-theory-list",
  theoryItem: (slug) => `ax-theory-item-${slug}`,
  theoryLink: (slug) => `ax-theory-link-${slug}`,
  featured: "ax-home-featured",
  featuredLink: "ax-home-featured-link",
  featuredDate: "ax-home-featured-date",
  intelFeed: "ax-home-intel-feed",
  intelFeedItem: (i) => `ax-home-intel-feed-item-${i}`,
};

export const THEORY = {
  root: "ax-theory-detail",
  title: "ax-theory-title",
  narrative: "ax-theory-narrative",
  counterEvidence: "ax-theory-counter-evidence",
  supportingEvidence: "ax-theory-supporting-evidence",
  keyFigures: "ax-theory-key-figures",
  credibilityBar: "ax-credibility-bar",
  credibilityTrend: "ax-credibility-trend",
  credibilitySlider: "ax-credibility-slider",
  credibilitySubmit: "ax-credibility-submit",
  paywall: "ax-paywall",
  paywallTeaser: "ax-paywall-teaser",
  paywallMonthly: "ax-paywall-monthly",
  paywallYearly: "ax-paywall-yearly",
  commentList: "ax-comment-list",
  commentInput: "ax-comment-input",
  commentSubmit: "ax-comment-submit",
  commentItem: (id) => `ax-comment-${id}`,
  commentReply: (id) => `ax-comment-reply-${id}`,
  commentUpvote: (id) => `ax-comment-upvote-${id}`,
  commentDownvote: (id) => `ax-comment-downvote-${id}`,
  sortHot: "ax-sort-hot",
  sortNew: "ax-sort-new",
  sortTop: "ax-sort-top",
};

export const ACCOUNT = {
  root: "ax-account-root",
  codename: "ax-account-codename",
  passphraseInput: "ax-account-passphrase-input",
  passphraseSubmit: "ax-account-passphrase-submit",
  subscriptionStatus: "ax-account-subscription-status",
  cancelButton: "ax-account-cancel-button",
};

export const RECOVER = {
  root: "ax-recover-root",
  codenameInput: "ax-recover-codename",
  passphraseInput: "ax-recover-passphrase",
  submit: "ax-recover-submit",
};

export const ADMIN = {
  loginRoot: "ax-admin-login",
  usernameInput: "ax-admin-username",
  passwordInput: "ax-admin-password",
  loginSubmit: "ax-admin-submit",
  dashboardRoot: "ax-admin-dashboard",
  statsCard: "ax-admin-stats",
  statsTile: (key) => `ax-admin-tile-${key}`,
  topDossiers: "ax-admin-top-dossiers",
  topDossierRow: (slug) => `ax-admin-top-dossier-${slug}`,
  funnel: "ax-admin-funnel",
  funnelRow: (key) => `ax-admin-funnel-${key}`,
  activityLog: "ax-admin-activity",
  activityRow: (i) => `ax-admin-activity-row-${i}`,
  commentRow: (id) => `ax-admin-comment-row-${id}`,
  deleteComment: (id) => `ax-admin-delete-${id}`,
  logout: "ax-admin-logout",
  seedSyncButton: "ax-admin-seed-sync-button",
  seedSyncResult: "ax-admin-seed-sync-result",
};

export const PAYMENT = {
  successRoot: "ax-payment-success",
  status: "ax-payment-status",
  goAccount: "ax-payment-go-account",
};

export const EVIDENCE = {
  section: "ax-evidence-section",
  elevatedSection: "ax-evidence-elevated",
  underReviewSection: "ax-evidence-under-review",
  elevatedList: "ax-evidence-elevated-list",
  underReviewList: "ax-evidence-under-review-list",
  tabSupporting: "ax-evidence-tab-supporting",
  tabCounter: "ax-evidence-tab-counter",
  list: "ax-evidence-list",
  card: (hash) => `ax-evidence-card-${hash.slice(0, 12)}`,
  cardBadge: (hash) => `ax-evidence-card-badge-${hash.slice(0, 12)}`,
  voteUp: (hash) => `ax-evidence-vote-up-${hash.slice(0, 12)}`,
  voteDown: (hash) => `ax-evidence-vote-down-${hash.slice(0, 12)}`,
  flagBtn: (hash) => `ax-evidence-flag-${hash.slice(0, 12)}`,
  flagMenu: (hash) => `ax-evidence-flag-menu-${hash.slice(0, 12)}`,
  shareBtn: (hash) => `ax-evidence-share-${hash.slice(0, 12)}`,
  submitOpen: "ax-evidence-submit-open",
  submitForm: "ax-evidence-submit-form",
  submitType: "ax-evidence-submit-type",
  submitContent: "ax-evidence-submit-content",
  submitSourceUrl: "ax-evidence-submit-source-url",
  submitButton: "ax-evidence-submit-button",
  submitReceipt: "ax-evidence-submit-receipt",
};

export const EVIDENCE_RECORD = {
  root: "ax-evidence-record",
  header: "ax-evidence-record-header",
  classification: "ax-evidence-record-classification",
  dossier: "ax-evidence-record-dossier",
  content: "ax-evidence-record-content",
  source: "ax-evidence-record-source",
  voteDisplay: "ax-evidence-record-votes",
  statusBadge: "ax-evidence-record-status",
  submittedAt: "ax-evidence-record-submitted-at",
  viewDossierCta: "ax-evidence-record-view-dossier",
  submitOwnCta: "ax-evidence-record-submit-own",
  shareLine: "ax-evidence-record-share-line",
  copyShare: "ax-evidence-record-copy-share",
};
